import React from "react";

const ClassyDonationImpact = ({impactFields}) => {
    const impact = JSON.parse(`${impactFields}`);

    return(
        <div className="ClassyDonate-impact">
            <div className="ClassyDonate-impact-imageWrapper">
                <img src={impact.icon} alt={impact.icon_alt}/>
            </div>
            <div className="ClassyDonate-impact-textWrapper">
                <p className="ClassyDonate-impact-highlightTitle">{impact.impact_title}</p>
                <p className="ClassyDonate-impact-highlightText">{impact.impact_description}</p>
            </div>
        </div>
    );
};

export default ClassyDonationImpact;
